export var UserBlockReasonEnum;
(function (UserBlockReasonEnum) {
    UserBlockReasonEnum["TOAST_DEPRECATION"] = "toast_deprecation";
})(UserBlockReasonEnum || (UserBlockReasonEnum = {}));
//# sourceMappingURL=UserBlockReasonEnum.js.map